import React from 'react';
import * as utils from "../utils";
import Contact from "./Contact";


//Faktureringskort
class ChargeCard extends React.Component {

    render() {
        var loans = this.props.loans;
        var indexType = this.props.indexType;
        var summary = this.props.summary;
        var indexLoanLast;
        var showInfo = false;

        return  <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
            <div>
                <div className="d-xl-none">
                    <div key={indexType} className='card-body list padding-0'>
                        <table className="tableLoanCol">
                            <tbody>
                            {loans.map(function (loan, indexLoan) {
                                indexLoanLast = indexLoan;
                                if (utils.isShowingUpdatetMarking(loan.receivedTime)) {
                                    showInfo = true;
                                }
                                return (
                                    <React.Fragment>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Kreditor</th>
                                        <td className="bold">{loan.financialInstitutionName}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Rentebærende saldo (forfalt)</th>
                                        <td>kr {utils.formatNumber(loan.interestBearingBalance)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Ikke rentebærende saldo (utestående)</th>
                                        <td>kr {utils.formatNumber(loan.nonInterestBearingBalance)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Medlåntaker</th>
                                        <td>{utils.coborrower(loan.coBorrower)}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Oppdatert i Gjeldsregisteret</th>
                                        <td>{loan.receivedTime} <utils.checkUpdatetMarking datetime={loan.receivedTime}/></td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, false)}>
                                        <th>Oppdatert hos kreditor</th>
                                        <td>{loan.processedTime}</td>
                                    </tr>
                                    <tr className={utils.tableStripes(indexLoan, true)}>
                                        <th>Melding om feil</th>
                                        <td><Contact loan={loan}/></td>
                                    </tr>
                                    </React.Fragment>
                                )
                            })}
                            <tr style={{borderBottomWidth: '0px'}} className={utils.tableStripes(indexLoanLast+1, true)}>
                                <td className="sum sumPadding">SUM Rentebærende saldo</td>
                                <td className="sum sumPadding">NOK {utils.formatNumber(summary.totalInterestBearingBalanceChargeCard)}</td>
                            </tr>
                            <tr style={{borderBottomWidth: '0px'}} className={utils.tableStripes(indexLoanLast+1, true)}>
                                <td className="sum">SUM Ikke rentebærende saldo</td>
                                <td className="sum">NOK {utils.formatNumber(summary.totalNonInterestBearingBalanceChargeCard)}</td>
                            </tr>
                            <utils.showUpdatetMarkingInfo showInfo={showInfo} indexLoanLast={indexLoanLast+1} colspan={2}/>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="d-none d-xl-block">
                    <div key={indexType} className='card-body list padding-0'>
                        <table className="tableLoanRow">
                            <tbody>
                            <tr>
                                <th className="headerLeft">Kreditor</th>
                                <th className="headerRight">Rentebærende<br/>saldo kr (forfalt)</th>
                                <th className="headerRight">Ikke rentebærende<br/>saldo kr (utestående)</th>
                                <th className="headerLeft">Medlåntaker</th>
                                <th className="headerLeft">Oppdatert i<br/>Gjeldsregisteret</th>
                                <th className="headerLeft">Oppdatert hos<br/>kreditor</th>
                                <th className="headerLeft">Melding<br/>om feil</th>
                            </tr>
                            {loans.map(function (loan, indexLoan) {
                                indexLoanLast = indexLoan;
                                if (utils.isShowingUpdatetMarking(loan.receivedTime)) {
                                    showInfo = true;
                                }
                                return (
                                    <tr>
                                        <td className="cellLeftBold">{loan.financialInstitutionName}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.interestBearingBalance)}</td>
                                        <td className="cellRight nowrap">{utils.formatNumber(loan.nonInterestBearingBalance)}</td>
                                        <td className="cellLeft nowrap">{utils.coborrower(loan.coBorrower)}</td>
                                        <td className="cellLeft"><utils.wrapDateTime datetime={loan.receivedTime}/> <utils.checkUpdatetMarking datetime={loan.receivedTime}/></td>
                                        <td className="cellLeft"><utils.wrapDateTime datetime={loan.processedTime}/></td>
                                        <td className="cellLeft"><Contact loan={loan}/></td>
                                    </tr>
                                )
                            })}
                            <tr style={{borderBottomWidth: '0px'}}>
                                <td className="cellLeft cellSum">SUM</td>
                                <td className="cellRight cellSum nowrap">{utils.formatNumber(summary.totalInterestBearingBalanceChargeCard)}</td>
                                <td className="cellRight cellSum nowrap">{utils.formatNumber(summary.totalNonInterestBearingBalanceChargeCard)}</td>
                                <td className="cellRight cellSum" colSpan={4}>&nbsp;</td>
                            </tr>
                            <utils.showUpdatetMarkingInfo showInfo={showInfo} indexLoanLast={indexLoanLast} colspan={9}/>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default ChargeCard;